import { call } from "redux-saga/effects";


let getListTrackingModule = null;
export function* getListTracking({ pageNumber, update, loadComplete=false, isNotification }) {
  if (!getListTrackingModule) {
    getListTrackingModule = yield call(() => import('./get-list-tracking'));
  }
  //llamada a modulo
  yield call(getListTrackingModule.getListTracking, { pageNumber, update, loadComplete, isNotification })
}

let getDetailTrackingModule = null;
export function* getDetailTracking({ handlingCode = 0, co }) {
  if(!getDetailTrackingModule){
    getDetailTrackingModule = yield call(() => import('./get-detail-tracking'))
  }
  yield call(getDetailTrackingModule.getDetailTracking, {handlingCode, co })
  // llamada a modulo
}
let getSlotsTrackingModule = null;
export function* getSlotsTracking({ handlingCode = 0, id, coOrCp, operationType }) {
  if(!getSlotsTrackingModule){
    getSlotsTrackingModule = yield call(() => import('./get-slots-tracking'))
  }
  yield call(getSlotsTrackingModule.getSlotsTracking, { handlingCode, id, coOrCp, operationType })
  //llamada modulo
}
let postModifyAppointmentModule = null;
export function* postModifyAppointment({ handlingCode = 0, payload }) {
  if(!postModifyAppointmentModule){
    postModifyAppointmentModule = yield call(() => import('./post-modify-appointment'))
  }
  yield call(postModifyAppointmentModule.postModifyAppointment, {handlingCode, payload})
  //llamada modulo
}
let postCreateAppointmentModule = null;
export function* postCreateAppointment({ handlingCode = 0, payload }) {
  if(!postCreateAppointmentModule){
    postCreateAppointmentModule = yield call(() => import('./post-create-appointment'))
  }
  yield call(postCreateAppointmentModule.postCreateAppointment, {handlingCode, payload})
  //llamada modulo
}
let getOrderDetailsModule = null;
export function* getOrderDetails({handlingCode = 0, customerOrderCode, logged}) {
  if(!getOrderDetailsModule){
    getOrderDetailsModule = yield call(() => import('./get-order-details'))
  }
  yield call(getOrderDetailsModule.getOrderDetails, {handlingCode, customerOrderCode, logged})
  // llamada modulo
}
let getStatusCelerisModule = null;
export function* getCelerisInfo({handlingCode = 0, co, sho}) {
  if(!getStatusCelerisModule){
    getStatusCelerisModule = yield call(() => import('./get-celeris-info'))
  }
  yield call(getStatusCelerisModule.getCelerisInfo, {handlingCode, co, sho})
  // llamada modulo
}
